import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface InfoBubbleFooterActionsProps {
  $justifyContentRight?: boolean;
}

/*
 * Style.
 */

const StyledFooterActionsDiv = styled.div<InfoBubbleFooterActionsProps>`
  display: flex;
  justify-content: ${(p) => (p.$justifyContentRight ? 'flex-end' : 'flex-start')};

  margin-top: 20px;
  margin-left: -2px;
  margin-right: -2px;

  & > * {
    margin: 0 2px;
  }
`;

/*
 * Component.
 */

export const InfoBubbleFooterActions: FC<PropsWithChildren<InfoBubbleFooterActionsProps>> = (props) => (
  <StyledFooterActionsDiv $justifyContentRight={props.$justifyContentRight}>
    {props.children}
  </StyledFooterActionsDiv>
);
